import { AdmissionGroup, AdmissionGroupItem } from '@domain/admission-group';
import { EventSection, EventSectionItem } from '@domain/event-section';

import { MoveOfferType } from '../../../hooks/admissions/use-move-offer';

export const removeOfferItemFromPosition = (
  from: { type: MoveOfferType; id: string },
  offerId: string,
  sections: EventSection[],
  groups: AdmissionGroup[]
): EventSectionItem | AdmissionGroupItem | null => {
  if (from.type === 'section') {
    const fromSection = sections.find((s) => s.id === from.id);
    if (fromSection) {
      const itemIndex = fromSection.items.findIndex((item) => item.id === offerId);
      if (itemIndex !== -1) {
        return fromSection.items.splice(itemIndex, 1)[0];
      }
    }
  } else if (from.type === 'offer_group') {
    const fromGroup = groups.find((g) => g.id === from.id);
    if (fromGroup) {
      const itemIndex = fromGroup.items.findIndex((item) => item.id === offerId);
      if (itemIndex !== -1) {
        return fromGroup.items.splice(itemIndex, 1)[0];
      }
    }
  }
  return null;
};
